import React from 'react';
import './style/services.css'
import { BiCheck } from 'react-icons/bi'

function Services() {
    return (
        <section id='services' className='box4'>
            <h5>what I Offer</h5>
            <h2>Services</h2>
            <div className="container services__container">
                <article className="services">
                    <div className="services__head">
                        <h3>UI/UX Design</h3>
                    </div>

                    <ul className="services__list">
                        <li><BiCheck className='services__list-icon' />
                            <p>Basic design creation with figma</p>
                        </li>
                    </ul>
                </article>

                {/*==================== END OF UI/UX ================= */}

                <article className="services">
                    <div className="services__head">
                        <h3>Web Development</h3>
                    </div>

                    <ul className="services__list">
                        <li><BiCheck className='services__list-icon' />
                            <p>everything related to front-end web development</p>
                        </li>
                    </ul>
                </article>
                {/*==================== END OF WEB DEVELOPMENT================= */}
                {/* <article className="services">
                    <div className="services__head">
                        <h3>Content Creation</h3>
                    </div>

                    <ul className="services__list">
                        <li><BiCheck className='services__list-icon' />
                            <p>Lorem ipsum dolor sit amet consectetur</p>
                        </li>
                        <li><BiCheck className='services__list-icon' />
                            <p>Lorem ipsum dolor sit amet consectetur</p>
                        </li>
                    </ul>
                </article> */}
                {/*==================== END OF CONTENT CREATION================= */}

            </div>

        </section>
    );
}

export default Services;